var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoutOutlined, UserOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Dropdown, Typography, theme } from "antd";
import "./UserDropdown.scss";
import { useMemo } from "react";
const { useToken } = theme;
/**
 * Displays a user icon that, when clicked,
 * opens a dropdown with the user's name, role, and a logout option.
 *
 */
export const UserDropdown = (_a) => {
    var { name, role = "", onLogout, menu, user, authUrl, customerSignature } = _a, rest = __rest(_a, ["name", "role", "onLogout", "menu", "user", "authUrl", "customerSignature"]);
    const { token } = useToken();
    // Helper function to get the preferred content of first row
    const getPreferredName = () => {
        if (!user) {
            return name;
        }
        if (!user.firstName)
            return user.lastName;
        if (!user.lastName)
            return user.firstName;
        return `${user.firstName} ${user.lastName}`;
    };
    // Style to remove hover effect that comes from antd and fix the cursor
    const styleToRemoveHoverEffect = {
        backgroundColor: token.colorBgBase,
        cursor: "auto"
    };
    const userDropdownOptions = useMemo(() => {
        var _a;
        const options = [];
        options.push({
            key: "user",
            label: (_jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [_jsx(Typography.Text, { strong: true, children: getPreferredName() }), _jsx(Typography.Text, { "data-testid": "test-role-text", type: "secondary", children: (_a = user === null || user === void 0 ? void 0 : user.email) !== null && _a !== void 0 ? _a : role })] })),
            style: styleToRemoveHoverEffect
        }, { type: "divider" });
        if (menu && menu.items) {
            menu.items.forEach((item) => {
                options.push(item);
            });
            options.push({ type: "divider" });
        }
        if ((user === null || user === void 0 ? void 0 : user.profiles) && authUrl && customerSignature) {
            options.push({
                key: "user-profiles-options",
                label: (_jsx(Typography.Link, { href: `${authUrl}/${customerSignature}/profile`, children: "Switch profile" })),
                icon: _jsx(UserSwitchOutlined, {})
            }, { type: "divider" });
        }
        if (onLogout) {
            options.push({
                key: "logout",
                icon: _jsx(LogoutOutlined, {}),
                onClick: onLogout,
                label: "Log out"
            });
        }
        return options;
    }, [menu, user, onLogout, name, role, authUrl, customerSignature]);
    return (_jsx(Dropdown, Object.assign({}, rest, { trigger: ["hover", "click"], menu: Object.assign(Object.assign({}, menu), { items: userDropdownOptions }), placement: "bottomRight", className: "user-dropdown-wrapper", overlayClassName: "user-dropdown", children: _jsx("a", { "data-testid": "user-dropdown__trigger", children: _jsx(UserOutlined, { style: { fontSize: 19 } }) }) })));
};
